import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { ReferralLeaderboard } from "@/components/referral/ReferralLeaderboard";
import { Footer } from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

export default function Parrains() {
  const { t } = useI18n();
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[#04050a] text-slate-200" data-testid="parrains-page">
      <div className="max-w-2xl mx-auto px-5 pt-14 pb-10">
        <Link to="/"><img src="/logo-wide.png" alt="CLIP-EX" className="h-9 mb-10" /></Link>
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#3ad7ff]">{t("ref.label")}</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white mt-3" data-testid="parrains-title">{t("rl.page_title")}</h1>
        <p className="text-slate-400 mt-4 text-sm sm:text-base">{t("rl.page_sub")}</p>
        <ReferralLeaderboard className="mt-8" />
        <Link to={user ? "/parrainage" : "/login?mode=register"} data-testid="parrains-cta"
          className="cx-btn mt-8 w-full rounded-full py-3.5 text-sm font-semibold flex items-center justify-center gap-2">
          <Gift className="w-4 h-4" />{t(user ? "rl.cta_user" : "rl.cta_guest")}
        </Link>
      </div>
      <Footer />
    </div>
  );
}
